module.exports = __webpack_public_path__ + "5b1febaa0b5e63022cc26630531f2e3c.svg";